import React from 'react';
import './Team.css';

const Team = () => {
  const teamMembers = [
    {
      name: "Avais Ahmad Qarni",
      position: "Founder & CEO",
      image: "/api/placeholder/300/300"
    },
    {
      name: "Husain Shabbir", 
      position: "CTO",
      image: "/api/placeholder/300/300"
    },
    {
      name: "Muhammad Hashim",
      position: "Software Programmer",
      image: "/api/placeholder/300/300"
    }
  ];

  return (
    <section className="team section" id="team">
      <div className="container">
        <div className="section-header text-center">
          <p className="team-label">Senior Executives</p>
          <h2>See Our Skilled Expert Team</h2>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card" data-aos="fade-up" data-aos-delay={index * 200}>
              <div className="team-image">
                <div className="image-placeholder">
                  <i className="fas fa-user"></i>
                </div>
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <p>{member.position}</p>
                <div className="team-social">
                  <a href="#linkedin"><i className="fab fa-linkedin"></i></a>
                  <a href="#twitter"><i className="fab fa-twitter"></i></a>
                  <a href="#github"><i className="fab fa-github"></i></a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team; 